import { SAVE_SETTINGS } from '../actions'

const INIT_STATE = {
    apiKey : window.localStorage.getItem('app.apiKey') ||  "ENTER API KEY",
    contractCode :  window.localStorage.getItem('app.contractCode') || "ENTER CONTRACT CODE"
}

export default (state = INIT_STATE , action) => {
    switch(action.type){
        case SAVE_SETTINGS: 
            return {...state, ...action.payload}
        default : 
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/Settings/reducers/index.js